import React from 'react';
import ContactForm from '../layout/ContactUs';

function Footer() {
  return (
    <footer className="bg-revolution-dark text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          {/* Company Info */}
          <div>
            <div className="mb-6">
              <a href="https://www.revolutiontravel.ca/">
                <img 
                  alt="Revolution Travel Logo" 
                  src="https://s3.amazonaws.com/ttand/uploads/users/logos-light/smills.jpg"
                  className="h-16 object-contain"
                />
              </a>
            </div>

            <div className="space-y-4">
              <div className="flex items-center gap-x-2">
                <svg className="w-5 h-5" stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24">
                  <circle cx="12" cy="12" r="10"></circle>
                  <polyline points="12 6 12 12 16 14"></polyline>
                </svg>
                <span>Hours: 9:00 am - 6:00 pm (ET)</span>
              </div>

              <address className="flex items-start gap-x-2 not-italic">
                <svg className="w-5 h-5" stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24">
                  <polygon points="3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21"></polygon>
                  <line x1="9" x2="9" y1="3" y2="18"></line>
                  <line x1="15" x2="15" y1="6" y2="21"></line>
                </svg>
                <span>1003-55 York Street, Toronto, ON, M5J 1R7, Canada</span>
              </address>

              <div className="flex items-center gap-x-2">
                <svg className="w-5 h-5" stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24">
                  <path d="M7.21 15 2.66 7.14a2 2 0 0 1 .13-2.2L4.4 2.8A2 2 0 0 1 6 2h12a2 2 0 0 1 1.6.8l1.6 2.14a2 2 0 0 1 .14 2.2L16.79 15"></path>
                  <circle cx="12" cy="17" r="5"></circle>
                </svg>
                <span className="uppercase">TICO: 5003172</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-semibold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li><a href="https://www.revolutiontravel.ca/about-us" className="hover:text-red-400">About</a></li>
              <li><a href="https://www.revolutiontravel.ca/tours" className="hover:text-red-400">Tours</a></li>
              <li><a href="https://www.revolutiontravel.ca/blogs" className="hover:text-red-400">Blogs</a></li>
              <li><a href="https://www.revolutiontravel.ca/testimonials" className="hover:text-red-400">Testimonials</a></li>
            </ul>

            <div className="mt-8">
              <h3 className="text-xl font-semibold mb-6">Contact Info</h3>
              <ul className="space-y-3">
                <li className="flex items-center gap-x-2">
                  <svg className="w-4 h-4" stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24">
                    <rect width="14" height="20" x="5" y="2" rx="2" ry="2"></rect>
                    <path d="M12 18h.01"></path>
                  </svg>
                  <span>416-669-6505</span>
                </li>
                <li className="flex items-center gap-x-2">
                  <svg className="w-4 h-4" stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24">
                    <rect width="14" height="20" x="5" y="2" rx="2" ry="2"></rect>
                    <path d="M12 18h.01"></path>
                  </svg>
                  <span>416-367-8264 EXT 3299</span>
                </li>
                <li>
                  <a href="mailto:sean@revolutiontravel.ca" className="flex items-center gap-x-2 hover:text-red-400">
                    <svg className="w-4 h-4" stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24">
                      <path d="M22 17a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9.5C2 7 4 5 6.5 5H18c2.2 0 4 1.8 4 4v8Z"></path>
                      <path d="M6.5 5C9 5 11 7 11 9.5V17a2 2 0 0 1-2 2v0"></path>
                    </svg>
                    <span>kimberly@revolutiontravel.ca</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Contact Form */}
          <div>
            <ContactForm />
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="mt-12 pt-8 border-t border-gray-700">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
            <div className="flex items-center gap-4">
              <span className="font-medium">Follow Us:</span>
              <div className="flex gap-4">
                <a href="https://www.facebook.com/revolutiontravelgroup" target="_blank" rel="noopener noreferrer" className="hover:text-red-400">
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 512 512">
                    <path d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"></path>
                  </svg>
                </a>
                <a href="https://www.instagram.com/revolution_travel_group" target="_blank" rel="noopener noreferrer" className="hover:text-red-400">
                  <svg className="w-6 h-6" stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24">
                    <rect width="20" height="20" x="2" y="2" rx="5" ry="5"></rect>
                    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                    <line x1="17.5" x2="17.51" y1="6.5" y2="6.5"></line>
                  </svg>
                </a>
                <a href="https://www.tiktok.com/@revolutiontravelgroup" target="_blank" rel="noopener noreferrer" className="hover:text-red-400">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M16 8.24537V15.5C16 19.0899 13.0899 22 9.5 22C5.91015 22 3 19.0899 3 15.5C3 11.9101 5.91015 9 9.5 9C10.0163 9 10.5185 9.06019 11 9.17393V12.3368C10.5454 12.1208 10.0368 12 9.5 12C7.567 12 6 13.567 6 15.5C6 17.433 7.567 19 9.5 19C11.433 19 13 17.433 13 15.5V2H16C16 4.76142 18.2386 7 21 7V10C19.1081 10 17.3696 9.34328 16 8.24537Z"></path>
                  </svg>
                </a>
              </div>
            </div>
            
            <div className="text-sm">
              <a href="https://www.revolutiontravel.ca/content/policy" className="hover:text-red-400">Privacy Policy</a>
              <span className="mx-2">|</span>
              <span>© 2024 Revolution Travel Group</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;